import { NsContent } from 'components/common/ns-content/NsContent';
import { NsProgress } from 'components/common/ns-progress/NsProgress';

export const testId = 'directSalesHeaderTestId';

export const DirectSalesHeader = () => {
  return (
    <>
      <link
        rel="canonical"
        href="https://www.britishgas.co.uk/new-energy/sales"
      />
      <NsContent data-testid={testId}>
        <NsProgress />
        <h1>Get an energy quote in minutes</h1>
        <h5>Tell us about your property</h5>
      </NsContent>
    </>
  );
};

export default DirectSalesHeader;
